import { http } from "@canvas/api";
import store from "@/store";

export interface GeneratePdfReq {
  endpoint: "template.api.v2.template.:templateName.pdf";
  body: {
    data: GeneratePdfRequestBody;
    templateName: string;
  };
}

export interface GeneratePdfRequestBody {
  data: { [key: string]: any };
  key?: string;
  renderconfs: { [key: string]: any };
}

export interface GeneratePdfRes {}

export function post(req: GeneratePdfReq): Promise<GeneratePdfRes> {
  const baseUrl = store.state.appModule.config?.baseUrl;
  const endpoint = store.state.appModule.config && store.state.appModule.config.serviceConfigMap.template.path;
  const code = store.state.appModule.auth?.tokenResponse?.accessToken;

  // @canvas/api wraps axios. As of @canvas/api@0.5.7 the axios dependency
  // does not download PDF binary data correctly. Using fetch as an escape
  // hatch here as it does not cause any problems.
  const res = fetch(
    `${baseUrl}/${endpoint}/v2/template/${req.body.templateName}/pdf`,
    {
      method: 'POST',
      body: JSON.stringify(req.body.data),
      headers: {
        authorization: `Bearer ${code}`,
        'Content-Type': 'application/pdf'
      }
    }
  );
  return res;
  // return http
  //   .POST(
  //     `/${endpoint}/v2/template/${req.body.templateName}/pdf`,
  //     JSON.stringify(req.body.data),
  //     {}
  //   )
  //   .then((response: GeneratePdfRes) => {
  //     // validate response here
  //     return response;
  //   })
  //   .catch(err => {
  //     return Promise.reject(err);
  //   });
}
